import React, { useEffect } from 'react';

const ToastPopup = ({ message, setToast, position = "center", opacity = "90" }) => {
  useEffect(() => {
    const timer = setTimeout(() => setToast(false), 1500);
    return () => clearTimeout(timer);
  }, [setToast]);

  return (
    <div className='toast-popup' data-position={position} data-opacity={opacity}>
      <div className='animation-3 toast-box'>
          <p className="text-box">{message}</p>
      </div>
    </div>
  );
};

export default ToastPopup;
